import _ from "underscore";
import ChartGenerator from "../../../chart/ChartGenerator";
import {getMaxScaleValue, getVerticalGridCount} from "../../../chart/utils";
import UserTime from "../../../user_time";
import {atImgPath} from "../../../atBrowserUtils";

function ColumnChartGenerator() {}

ColumnChartGenerator.prototype = _.create(ChartGenerator.prototype, {
    MAX_VERTICAL_GRIDS: 11,

    _prepareChartSettings: function(chartData, config)
    {
        var collectedData = this._getCollectedData(chartData, config["userToday"], config["userHireDate"]);
        var dateFormat = config["dateFormat"];

        var chartMargins = this._getMargins(collectedData);

        var chartGraphs = this._prepareChartGraphs(collectedData, config["colorScheme"], dateFormat);

        var valueAxisMaxValue = getMaxScaleValue(collectedData.maxSummaryDayData, this.MAX_VERTICAL_GRIDS);
        var valueAxisGridCount = getVerticalGridCount(valueAxisMaxValue, 0, this.MAX_VERTICAL_GRIDS);
        var valueAxisLabelFunction = this._getValueAxisLabelFunction();

        var categoryAxisFunction = this._getCategoryAxisFunction();
        var categoryGridCount = this._getCategoryGridCount(collectedData);
        var categoryAxisLabelFunction = this._getCategoryAxisLabelFunction(dateFormat);

        var dataProvider = this._prepareDataProvider(collectedData, valueAxisMaxValue);

        return {
            "type": "serial",
            "autoResize": false,

            "startDuration": 0,
            "startEffect": "easeOutSine",
            "sequencedAnimation": true,

            "theme": "light",
            "columnWidth": 0.9,
            "columnSpacing": 0,
            "fontSize": 11,
            "addClassNames": true,

            "autoMargins": false,
            "marginTop": chartMargins["top"],
            "marginBottom": chartMargins["bottom"],
            "marginLeft": chartMargins["left"],
            "marginRight": chartMargins["right"],

            "chartCursor": {
                "oneBalloonOnly": true,
                "categoryBalloonEnabled": false,
                "balloonPointerOrientation": "vertical",
                "cursorAlpha": 0,
                "zoomable": false
            },

            "graphs": chartGraphs,

            "valueAxes": [
                {
                    "id": "main",
                    "maximum": valueAxisMaxValue,
                    "stackType": "regular",
                    "autoGridCount": false,
                    "strictMinMax": true,
                    "gridCount": valueAxisGridCount,
                    "labelFunction": valueAxisLabelFunction,
                    "axisAlpha": 0.11,
                    "tickLength": 0
                },
                {
                    "id": "hidden",
                    "gridCount": 0,
                    "position": "right",
                    "synchronizeWith": "main",
                    "synchronizationMultiplier": 1,
                    "autoGridCount": false,
                    "axisAlpha": 0.11,
                    // it need for show axis if auto margin off (hack)
                    "minimum": 0,
                    "logarithmic": true
                }
            ],

            "categoryField": "date",
            "categoryAxis": {
                "parseDates": true,
                "minPeriod": "DD",
                "firstDayOfWeek": config["weekStartDay"],
                "categoryFunction": categoryAxisFunction,

                "gridPosition": "start",
                "gridThickness": 1,
                "tickLength": 30,
                "tickPosition": "start",
                "autoGridCount": false,
                "gridCount": categoryGridCount,

                "fontSize": 11,
                "labelOffset": 3,
                "boldLabels": false,
                "markPeriodChange": false,
                "boldPeriodBeginning": false,
                "centerLabelOnFullPeriod": false,
                "labelFunction": categoryAxisLabelFunction,
                "color": "#797C80" //TODO adjust color
            },
            "dataProvider": dataProvider
        }
    },

    _updateSettingsForExport: function(settings, chartData, config)
    {
        var scales = this._getChartScales(config);
        settings["marginTop"] *= scales.vertical;
        settings["marginBottom"] *= scales.vertical;
        settings["marginLeft"] *= scales.horizontal;
        settings["marginRight"] *= scales.horizontal;
        settings["fontSize"] = settings["fontSize"] * scales.common;
        settings["categoryAxis"]["fontSize"] *= scales.common;
        settings["categoryAxis"]["tickLength"] *= scales.common;
        settings["categoryAxis"]["labelOffset"] *= scales.common;
        _.each(settings["graphs"], function(graph)
        {
            if (graph["valueField"] == "today")
            {
                graph["bulletOffset"] *= scales.common;
                graph["bulletSize"] *= scales.common;
                graph["lineThickness"] *= scales.common;
                graph["dashLength"] *= scales.common;
            }
        });

    },

    _prepareDataProvider: function(collectedData, maxScaleValue)
    {
        var dataProvider = [];
        var dataContext = collectedData.daysData;
        for (var i = 0; i < dataContext.length; i++)
        {
            var dayData = dataContext[i];

            var isToday = dayData.isToday;
            var isWeekend = dayData.isWeekend;
            var thereAreNoDayData = dayData.thereAreNoDayData;

            var dayDuration = isWeekend ? maxScaleValue : dayData.dayDuration;

            var balloon = thereAreNoDayData ? dayDuration : (dayData.overtime + dayData.leaveTime + dayData.workingTimeRest);
            var oneDayContext = {
                "date": dayData.date,

                "workingTimeRest": dayData.workingTimeRest,
                "overtime": dayData.overtime,
                "leaveTime": dayData.leaveTime,
                "dayDuration": dayDuration,
                "balloon": balloon,

                "balloonContext": {
                    "date": dayData.date,
                    "workingTime": dayData.initialData.workingTime,
                    "overtime": dayData.initialData.overtime,
                    "leaveTime": dayData.initialData.leaveTime,
                    "isBeforeHireDate": dayData.isBeforeHireDate,
                    "isWeekend": isWeekend,
                    "thereAreNoDayData": thereAreNoDayData,
                    "corporateDayName": dayData.corporateDayName,
                }
            };

            var defaultColorScheme = ColumnChartGenerator.colorScheme.DEFAULT;
            var dayDurationColor;
            if (isToday)
            {
                oneDayContext["today"] = maxScaleValue;
                oneDayContext["todayBullet"] = this._getTodayBulletURL();
                dayDurationColor = defaultColorScheme.todayDayDuration;
            }
            else
            {
                if (isWeekend)
                {
                    dayDurationColor = defaultColorScheme.weekendDuration;
                }
                else
                {
                    dayDurationColor = defaultColorScheme.dayDuration;
                }

            }
            oneDayContext["dayDurationColor"] = dayDurationColor;
            dataProvider.push(oneDayContext);
        }
        return dataProvider;
    },

    /**
     * Get additional event listeners specified for current chart
     */
    _getAdditionalEventListeners: function()
    {
        return [{
            "event": "clickGraphItem",
            "method": function(event)
            {
                var date = event.item.dataContext.date;
                window.location.href = ViewTTPageUtils.createEnterTTURL(date);
            }
        }];
    },

    _getCollectedData: function(dayInfoArray, userToday, userHireDate)
    {
        var maxSummaryDayData = 0;
        var daysData = [];
        for (var i = 0; i < dayInfoArray.length; i++)
        {
            var dayInfo = dayInfoArray[i];
            var date = dayInfo["date"];
            var isToday = date.isSameDate(userToday);

            var workDayDuration = dayInfo["workdayDuration"];
            var isWeekend = workDayDuration == 0;

            var leaveTime = 0;
            var initialLeaveTime = 0;
            if (!_.isNull(dayInfo["leave"]))
            {
                leaveTime = dayInfo["leave"]["leaveTime"];
                initialLeaveTime = leaveTime;
            }

            var overtime = 0;
            var initialOvertime = 0;
            if (!_.isNull(dayInfo["overtime"]))
            {
                var reportedOvertime = dayInfo["overtime"]["reported"];
                var autoOvertime = dayInfo["overtime"]["auto"];

                overtime = _.isNull(reportedOvertime) ? autoOvertime : reportedOvertime;
                initialOvertime = overtime;
                if (overtime < 0)
                {
                    overtime = 0;
                }
            }

            var initialWorkingTime = dayInfo["totalWorkingTime"];
            var workingTimeRest = initialWorkingTime - overtime;
            var dayDuration = workDayDuration - (workingTimeRest + overtime + leaveTime);
            if (dayDuration < 0)
            {
                dayDuration = 0;
            }

            var summaryDayData = dayDuration + overtime + workingTimeRest + leaveTime;

            if (summaryDayData > maxSummaryDayData)
            {
                maxSummaryDayData = summaryDayData;
            }

            var thereAreNoDayData = (leaveTime == 0 && overtime == 0 && workingTimeRest == 0);

            // we need to convert data to hour because it more convenient
            daysData.push({
                              "date": date,

                              "dayDuration": this._toHour(dayDuration),
                              "leaveTime": this._toHour(leaveTime),
                              "workingTimeRest": this._toHour(workingTimeRest),
                              "overtime": this._toHour(overtime),

                              "isToday": isToday,
                              "isWeekend": isWeekend,
                              "thereAreNoDayData": thereAreNoDayData,
                              "isBeforeHireDate": date < userHireDate,

                              "initialData": {
                                  "workingTime": initialWorkingTime,
                                  "overtime": initialOvertime,
                                  "leaveTime": initialLeaveTime
                              },
                              "corporateDayName": dayInfo.corporateDayName
                          });
        }

        return {
            "maxSummaryDayData": this._toHour(maxSummaryDayData),
            "daysData": daysData
        };
    },
    _getValueAxisLabelFunction: function()
    {
        var self = this;
        return function(val)
        {
            return self._formatDataTime(self._toMinutes(val));
        };
    },

    _getCategoryAxisLabelFunction: function(dateFormat)
    {
        return function(_, date)
        {
            return dateFormat.formatDate(date);
        }
    },

    /**
     * Create function that returns category as is
     * Because we use already parsed dates in data provider
     */
    _getCategoryAxisFunction: function()
    {
        return function(date)
        {
            return date;
        }
    },

    _toHour: function(val)
    {
        return val / 60;
    },

    _toMinutes: function(val)
    {
        return val * 60;
    },

    _formatDataTime: function(val)
    {
        return UserTime.formatTime(val);
    },

    /*
     Get number of grids for horizontal axis
     Its depends on number of visible days
     */
    _getCategoryGridCount: function(collectedData)
    {
        var nDays = collectedData.daysData.length;
        var nGrids;
        if (nDays < 49) // ~7 weeks
        {
            nGrids = nDays / 7;
        }
        else if (nDays < 183) // ~6 month
        {
            nGrids = nDays / 30;
        }
        else if (nDays < 550) // ~6 quarter
        {
            nGrids = nDays / 90;
        }
        else
        {
            nGrids = nDays / 180;
        }
        return Math.ceil(nGrids);
    },

    _getMargins: function(collectedData)
    {
        var nDays = collectedData.daysData.length;

        var left = 0;
        var right = 0;
        var top = 20;
        var bottom = 40;
        if (nDays <= 7)
        {
            left = 180;
            right = 160;
        }
        else if (nDays <= 14)
        {
            left = 110;
            right = 80;
        }
        else
        {
            left = 50;
            right = 5;
        }

        return {
            "top": top,
            "bottom": bottom,
            "left": left,
            "right": right
        };
    },

    _getTodayBulletURL: function()
    {
        return atImgPath("viewtt/today.png");
    },

    /**
     * Prepare graphs for chart. Every graph represents one type of column
     */
    _prepareChartGraphs: function(collectedData, colorScheme, dateFormat)
    {
        var defaultColorScheme = ColumnChartGenerator.colorScheme.DEFAULT;
        var graphs = [];
        graphs.push(this._createDataGraph("leaveTime", colorScheme.leaveTime),
                    this._createDataGraph("workingTimeRest", colorScheme.workingTime),
                    this._createDataGraph("overtime", colorScheme.overtime));

        var dayDurationGraph = _.extend(this._createDataGraph("dayDuration", ""), {
            "colorField": "dayDurationColor"
        });
        graphs.push(dayDurationGraph);
        // column for show today bullet and border
        var todayGraph = _.extend(this._createDataGraph("today", ""), {
            "bulletOffset": 5,
            "bulletSize": 30,
            "customBulletField": "todayBullet",
            "fillAlphas": 0,
            "lineAlpha": 0.6,
            "lineColor": defaultColorScheme.todayBorder,
            "lineThickness": 1,
            "dashLength": 3,
            "clustered": false,
            "newStack": true,
            "columnWidth": 0.9
        });
        graphs.push(todayGraph);
        // transparent column for show balloon
        var balloonGraph = _.extend(this._createDataGraph("balloon", "#FFFFFF"), {
            "newStack": true,
            "showBalloon": true,
            "balloonFunction": this._createBalloonFunction(dateFormat),
            "balloon": {
                "adjustBorderColor": false,
                "borderColor": defaultColorScheme.balloonBorder,
                "borderThickness": 1,
                "fillAlpha": 0.9
            },
            "fillAlphas": 0
        });
        graphs.push(balloonGraph);
        return graphs;
    },

    /**
     * Create base graph
     * @param valueField name for data provider
     * @param fillColor color of graph
     * @returns {{showBalloon: boolean, fillAlphas: number, fillColors: *, lineThickness: number, clustered: boolean, type: string, valueField: *}}
     * @private
     */
    _createDataGraph: function(valueField, fillColor)
    {
        var fillAlpha = 0.85;
        return {
            "showBalloon": false,
            "fillAlphas": fillAlpha,
            "fillColors": fillColor,
            "lineAlpha": 0,
            "lineThickness": 0,
            "clustered": false,
            "type": "column",
            "valueField": valueField
        }
    }
    ,

    _createBalloonFunction: function(dateFormat)
    {
        var balloonTemplate = _.template(
                "<div class='daysChartBalloon'>" +
                "   <div class='date'>" +
                "       <%=dateFormat.formatDate(date)%> " +
                "           <%if(isBeforeHireDate){%>" +
                "               <%=messageResource.getMessage(\"view_tt.chart.balloon.before_hire\")%>" +
                "           <%} else if(isWeekend){%>" +
                "               <% if(corporateDayName){%>" +
                "                   <div class='separator'></div> " +
                "                   <%-corporateDayName%>" +
                "               <%}%>" +
                "               <%=messageResource.getMessage(\"view_tt.chart.balloon.weekend\")%>" +
                "           <%}%>" +
                "   </div>" +
                "   <div class='values'>" +
                "       <%if(workingTime != 0){%>" +
                "           <div><%=messageResource.getMessage(\"view_tt.chart.balloon.w_t\", [self._formatDataTime(workingTime)])%></div>" +
                "       <%}%>" +
                "       <%if(overtime != 0){%>" +
                "           <div><%=messageResource.getMessage(\"view_tt.chart.balloon.o_t\", [self._formatDataTime(overtime)])%></div>" +
                "       <%}%>" +
                "       <%if(leaveTime != 0){%>" +
                "           <div><%=messageResource.getMessage(\"view_tt.chart.balloon.l_t\", [self._formatDataTime(leaveTime)])%></div>" +
                "       <%}%>" +
                "       <%if(thereAreNoDayData){%>" +
                "           <%=messageResource.getMessage(\"view_tt.chart.balloon.t_t\", [self._formatDataTime(0)])%>" +
                "       <%}%>" +
                "   </div>" +
                "   <div class='enterTtNote'><%=messageResource.getMessage(\"view_tt.chart.balloon.click_note\")%></div>" +
                "</div>"
        );

        var self = this;
        return function(item)
        {
            var context = item.dataContext;
            return balloonTemplate(_.extend(context["balloonContext"], {self: self, dateFormat: dateFormat}));
        };
    }
});

ColumnChartGenerator.colorScheme = {
    "DEFAULT": {
        "workingTime": "#397ec0",
        "overtime": "#7cd5da",
        "leaveTime": "#9a7eda",
        "dayDuration": "#F3F5F6",
        "todayDayDuration": "#FFF4C1",
        "weekendDuration": "#E0E6EC",
        "todayBorder": "#232323",
        "balloonBorder": "#b2b2b2"
    },
    "DEFAULT_GREY": {
        "workingTime": "#697f92",
        "overtime": "#8ed6e2",
        "leaveTime": "#a797cc"
    },
    "ORANGE": {
        "workingTime": "#70839e",
        "overtime": "#95cb61",
        "leaveTime": "#d9862e"
    },
    "ORANGE_GREY": {
        "workingTime": "#697f92",
        "overtime": "#91b56f",
        "leaveTime": "#d2a06b"
    },
    "RED": {
        "workingTime": "#70839e",
        "overtime": "#95cb61",
        "leaveTime": "#cf7272"
    },
    "RED_GREY": {
        "workingTime": "#697f92",
        "overtime": "#91b56f",
        "leaveTime": "#bc7c7c"
    }
};


export default ColumnChartGenerator;



// WEBPACK FOOTER //
// ./web/js/user/viewtt/chart/ColumnChartGenerator.js